/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const file_add = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="m9.59 2.5-.97-1.146A1 1 0 0 0 7.856 1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h2m6.25-2.563V8.064m2.188 2.187H8.061m7.11 0a4.922 4.922 0 1 1-9.844 0 4.922 4.922 0 0 1 9.844 0Z"
    />
  </svg>
)
export default file_add
